import { render, staticRenderFns } from "./OrientationVideos.vue?vue&type=template&id=76882cd6&scoped=true&"
import script from "./OrientationVideos.vue?vue&type=script&lang=js&"
export * from "./OrientationVideos.vue?vue&type=script&lang=js&"
import style0 from "./OrientationVideos.vue?vue&type=style&index=0&id=76882cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76882cd6",
  null
  
)

export default component.exports